import { useMemo } from "react";
import Card from "./Card.jsx";
import Ball from "../Ball.jsx";
import { getDistanceFromLast } from "../../lib/lotto.js";

export default function Distance({ rows }) {
  const data = useMemo(() => getDistanceFromLast(rows), [rows]);
  const sorted = data.slice().sort((a, b) => (b.distance ?? 0) - (a.distance ?? 0));
  const longest = sorted.slice(0, 8);
  const shortest = sorted.slice(-8).reverse();

  const fmt = (d) => (d == null ? "−" : d === 0 ? "방금" : `${d}회 전`);

  return (
    <Card title="마지막 출현 거리" subtitle="회차 기준" span={1}>
      <div className="grid-2">
        <div>
          <h4 className="muted">오랫동안 안 나온 번호</h4>
          {longest.map((d) => (
            <div key={d.num} className="row">
              <Ball n={d.num} />
              <span className="muted" style={{ marginLeft: 8 }}>
                {fmt(d.distance)}
              </span>
            </div>
          ))}
        </div>
        <div>
          <h4 className="muted">최근 자주 나온 번호</h4>
          {shortest.map((d) => (
            <div key={d.num} className="row">
              <Ball n={d.num} />
              <span className="muted" style={{ marginLeft: 8 }}>
                {fmt(d.distance)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
